document.addEventListener('DOMContentLoaded', function () {
    const allSwiper = document.querySelectorAll('.swiper-slider-custom');
    allSwiper.forEach(swiper => {
        const { 
            deskLg, deskMd, deskSm, port, tabletLg, tabletMd, 
            itemDeskLg, itemDeskMd, itemDeskSm, itemTabletLg, itemTabletMd, itemPort, itemMobile,
            rowsMobile
        } = swiper.dataset;
        const grid = {
            rows: 1
        }
        const navigation = {
            nextEl: ".swiper-custom-arrow.arrow-right",
            prevEl: ".swiper-custom-arrow.arrow-left",
        }
        const swiperItem = new Swiper(swiper, {
            slidesPerView: itemMobile,
            grid: {
                rows: rowsMobile,
            },
            breakpoints: {
                [tabletMd]: {
                    slidesPerView: itemTabletMd,
                    grid: grid,
                    navigation: navigation
                },
                [tabletLg]: {
                    slidesPerView: itemTabletLg,
                    grid: grid,
                    navigation: navigation
                },
                [port]: {
                    slidesPerView: itemPort,
                    grid: grid,
                    navigation: navigation
                },
                [deskSm]: {
                    slidesPerView: itemDeskSm,
                    grid: grid,
                    navigation: navigation
                },
                [deskMd]: {
                    slidesPerView: itemDeskMd,
                    grid: grid,
                    navigation: navigation
                },
                [deskLg]: {
                    slidesPerView: itemDeskLg,
                    grid: grid,
                    navigation: navigation
                }
            }
        })
    });


});